import { get } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { APP_CONFIG } from '@/config';
import type { UpsellPurchaseResponse } from '@/@types/upsell';

export const getUpsellPurchaseResult = async (
  transactionId: string,
  trackingInfo?: string,
  externalTransactionToken?: string,
) => {
  const queryParams = new URLSearchParams();
  if (trackingInfo !== undefined) queryParams.set('trackingInfo', trackingInfo);
  if (externalTransactionToken) queryParams.set('externalTransactionToken', externalTransactionToken);
  const queryString = queryParams.toString();

  return await get<UpsellPurchaseResponse>(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.upsellPurchaseResult(transactionId)}${queryString ? `?${queryString}` : ''}`,
  );
};
